<template>
  <div class="header">
    <div class="container">
      <div class="header-content">
        <!-- Logo区域 -->
        <div class="logo-container">
          <div class="logo">
            <!-- 这里是logo图片，您需要替换为您实际的logo图片 -->
            <img
                src="../assets/img/logo.png"
                alt="山东海洋资源勘测研究院"
                class="logo-img"
            />
          </div>
        </div>

        <!-- 主导航菜单 - 直接写死结构 -->
        <nav class="main-nav">
          <ul class="nav-list">
            <!-- 首页 -->
            <li class="nav-item">
              <a href="/" class="nav-link">
                <span class="nav-text">首页</span>
                <span class="underline"></span>
              </a>
            </li>

            <!-- 关于我们 - 有下拉菜单 -->
            <li class="nav-item has-dropdown">
              <a href="/about" class="nav-link">
                <span class="nav-text">关于青山</span>
                <span class="underline"></span>
              </a>

              <!-- 下拉菜单 -->
              <ul class="dropdown-menu">
                <li class="dropdown-item">
                  <a href="/about#jianjie" class="dropdown-link">
                    <span class="dropdown-text">公司简介</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
                <li class="dropdown-item">
                  <a href="/about#jingying" class="dropdown-link">
                    <span class="dropdown-text">经营范围</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
                <li class="dropdown-item">
                  <a href="/about#yingyong" class="dropdown-link">
                    <span class="dropdown-text">应用领域</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
                <li class="dropdown-item">
                  <a href="/about#qiye" class="dropdown-link">
                    <span class="dropdown-text">企业文化</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
              </ul>
            </li>

            <!-- 产品中心 - 有下拉菜单 -->
            <li class="nav-item has-dropdown">
              <a href="/products" class="nav-link">
                <span class="nav-text">产品中心</span>
                <span class="underline"></span>
              </a>

              <!-- 下拉菜单 -->
              <ul class="dropdown-menu">
                <li class="dropdown-item">
                  <a href="/product/ganggu" class="dropdown-link">
                    <span class="dropdown-text">钢骨架聚乙烯塑料复合管</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
                <li class="dropdown-item">
                  <a href="/product/duochong" class="dropdown-link">
                    <span class="dropdown-text">多重增强钢塑复合管</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
                <li class="dropdown-item">
                  <a href="/product/kongwang" class="dropdown-link">
                    <span class="dropdown-text">孔网钢带聚乙烯复合管</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
                <li class="dropdown-item">
                  <a href="/product/kongwang-pert" class="dropdown-link">
                    <span class="dropdown-text">PE-RT耐热孔网钢带复合管</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
                <li class="dropdown-item">
                  <a href="/product/pe" class="dropdown-link">
                    <span class="dropdown-text">PE管</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
                <li class="dropdown-item">
                  <a href="/product/gangsiwang" class="dropdown-link">
                    <span class="dropdown-text">钢丝网骨架聚乙烯复合管</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
                <li class="dropdown-item">
                  <a href="/product/boxian" class="dropdown-link">
                    <span class="dropdown-text">玻纤双高筋增强聚乙烯缠绕管</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
                <li class="dropdown-item">
                  <a href="/product/kela" class="dropdown-link">
                    <span class="dropdown-text">克拉管、高密度聚乙烯缠绕结构壁B型管</span>
                    <span class="dropdown-underline"></span>
                  </a>
                </li>
              </ul>
            </li>

            <!-- 应用案例 - 有下拉菜单 -->
            <li class="nav-item has-dropdown">
              <a href="/cases" class="nav-link">
                <span class="nav-text">工程案例</span>
                <span class="underline"></span>
              </a>

              <!-- 下拉菜单 -->
<!--              <ul class="dropdown-menu">-->
<!--                <li class="dropdown-item">-->
<!--                  <a href="/cases/assessment" class="dropdown-link">-->
<!--                    <span class="dropdown-text">海洋资源评估</span>-->
<!--                    <span class="dropdown-underline"></span>-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li class="dropdown-item">-->
<!--                  <a href="/cases/monitoring" class="dropdown-link">-->
<!--                    <span class="dropdown-text">海岸线监测</span>-->
<!--                    <span class="dropdown-underline"></span>-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li class="dropdown-item">-->
<!--                  <a href="/cases/environment" class="dropdown-link">-->
<!--                    <span class="dropdown-text">海洋环境调查</span>-->
<!--                    <span class="dropdown-underline"></span>-->
<!--                  </a>-->
<!--                </li>-->
<!--              </ul>-->
            </li>

            <!-- 联系我们 -->
            <li class="nav-item">
              <a href="/contact" class="nav-link">
                <span class="nav-text">联系我们</span>
                <span class="underline"></span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
       // 请替换为您的实际logo图片
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.header {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  font-family: 'Microsoft YaHei', 'Segoe UI', Arial, sans-serif;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.container {
  width: 80%; /* 设置宽度为页面的80% */
  margin: 0 auto;
  padding: 0 15px;
}

/* 头部内容布局 - logo和导航在同一行 */
.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 90px;
  padding: 10px 0;
}

/* Logo样式 */
.logo-container {
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0; /* 防止logo被压缩 */
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px; /* 稍微减少与导航菜单的间距 */
  height: 100%;
}

.logo-img {
  height: 60px;
  width: auto;
  max-width: 410px;
  object-fit: contain;
  display: block;
}

/* 主导航菜单 */
.main-nav {
  flex: 1;
  display: flex;
  justify-content: flex-end; /* 改为右对齐，充分利用空间 */
  margin-left: 0; /* 移除左侧外边距 */
  height: 100%;
}

.nav-list {
  display: flex;
  list-style: none;
  align-items: center;
  height: 100%;
  justify-content: flex-end; /* 导航项右对齐 */
  width: 100%; /* 占满剩余空间 */
}

.nav-item {
  position: relative;
  margin-left: 12px; /* 适当增加菜单项之间的间距 */
  margin-right: 12px; /* 适当增加菜单项之间的间距 */
  display: flex;
  align-items: center;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  padding: 12px 15px; /* 稍微调整内边距 */
  text-decoration: none;
  color: #333;
  font-size: 18px;
  font-weight: 500;
  position: relative;
  transition: color 0.3s ease;
  cursor: pointer;
  height: 100%;
  white-space: nowrap; /* 防止文本换行 */
}

.nav-text {
  position: relative;
  z-index: 2;
  letter-spacing: 0.5px;
}

/* 下划线动画效果 */
.underline {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background-color: #1fb53a;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

/* 只使用:hover伪类来控制悬停效果，不添加.active类 */
.nav-link:hover .underline {
  width: 85%;
}

.nav-link:hover {
  color: #1fb53a;
}

/* 下拉菜单样式 - 使用纯CSS控制显示隐藏 */
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  min-width: 200px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  list-style: none;
  z-index: 1001;
  padding: 10px 0;
  margin-top: 10px; /* 增加上边距，创建连接区域 */
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
}

/* 鼠标悬停在有下拉菜单的项上时显示下拉菜单 */
.nav-item.has-dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  padding: 0;
}

.dropdown-link {
  display: block;
  padding: 12px 24px;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  position: relative;
  transition: all 0.2s ease;
  cursor: pointer;
}

.dropdown-text {
  position: relative;
  z-index: 2;
  letter-spacing: 0.3px;
}

.dropdown-underline {
  position: absolute;
  bottom: 8px;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: #1fb53a;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.dropdown-link:hover .dropdown-underline {
  width: calc(100% - 48px);
}

.dropdown-link:hover {
  color: #1fb53a;
  background-color: #f5f9ff;
}

/* 下拉菜单连接区域 - 确保鼠标可以从主菜单平滑移动到下拉菜单 */
.nav-item.has-dropdown .dropdown-menu::before {
  content: '';
  position: absolute;
  top: -10px; /* 与margin-top相同 */
  left: 0;
  width: 100%;
  height: 10px;
  background: transparent;
}

/* 响应式设计 - 调整断点 */
@media (max-width: 1200px) {
  .container {
    width: 90%; /* 在中等屏幕上增加到90% */
  }

  .nav-item {
    margin-left: 10px;
    margin-right: 10px;
  }

  .nav-link {
    font-size: 17px;
    padding: 10px 12px;
  }
}

@media (max-width: 1100px) {
  .container {
    width: 95%; /* 在较小屏幕上增加到95% */
  }

  .logo-img {
    height: 55px;
    max-width: 350px;
  }

  .nav-item {
    margin-left: 8px;
    margin-right: 8px;
  }
}

@media (max-width: 992px) {
  .container {
    width: 100%; /* 在平板屏幕上恢复为100% */
    padding: 0 20px;
  }

  .header-content {
    flex-direction: column;
    align-items: center;
    padding: 15px 0;
    min-height: auto;
  }

  .logo {
    margin-right: 0;
    margin-bottom: 15px;
  }

  .logo-container {
    margin-bottom: 15px;
    width: 100%;
    justify-content: center;
    height: auto;
  }

  .main-nav {
    width: 100%;
    justify-content: center;
    margin-left: 0;
    height: auto;
  }

  .nav-list {
    flex-wrap: wrap;
    justify-content: center;
    height: auto;
  }

  .nav-item {
    margin: 0 8px 10px;
  }

  .dropdown-menu {
    position: static;
    box-shadow: none;
    border-top: 1px solid #eee;
    margin-top: 5px;
    width: 100%;
    opacity: 1;
    visibility: visible;
    transform: none;
  }
}

@media (max-width: 768px) {
  .header-content {
    padding: 12px 0;
  }

  .logo-img {
    height: 50px;
    max-width: 300px;
  }

  .nav-link {
    font-size: 16px;
    padding: 10px 12px;
  }

  .nav-item {
    margin: 0 6px 10px;
  }
}

@media (max-width: 576px) {
  .header-content {
    padding: 10px 0;
  }

  .logo-container {
    justify-content: center;
  }

  .nav-list {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .nav-item {
    width: 100%;
    text-align: center;
    margin: 8px 0;
  }

  .dropdown-menu {
    position: static;
    box-shadow: none;
    border-top: 1px solid #eee;
    margin-top: 5px;
    width: 100%;
  }
}
</style>